import jwtAuthService from "app/services/jwtAuthService";
import { useState, useEffect } from "react";

const useFseHide = () => {
    const data = jwtAuthService.getUser();
    const initialHide = data?.user?.ruoli.length === 1 && data.user.ruoli[0] === "FSE";

    const [hide, setHide] = useState(initialHide);

    useEffect(() => {
        const user = data?.user;
        if (user && user.ruoli.length === 1 && user.ruoli[0] === "FSE") {
            setHide(true);
        } else {
            setHide(false);
        }
    }, [data]);

    return hide;
};

export default useFseHide;
